import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import uiConfig from "../../config/uiConfig";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  IconButton,
  Chip,
  Tooltip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import TicketForm from "./TicketForm";




function TicketDialog({

  open,

  ticket,

  onClose,

  onSave,

  isSaving

}) {


  const formRef = useRef();

  const [isFormValid, setIsFormValid] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("[TicketDialog] isFormValid:", isFormValid, "isSaving:", isSaving);
  }, [isFormValid, isSaving]);

  const handleCopyLink = () => {
    if (!ticket) return;
    const link = `${window.location.origin}/tickets/${ticket.ticket_id}`;
    navigator.clipboard.writeText(link).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 1500);
    });
  };




  const handleSubmit = () => {

    formRef.current();

  };



  return (


    <Dialog

      open={open}

      onClose={() => {
        if (!isSaving) {
          onClose();
        }
      }}

      disableEscapeKeyDown={isSaving}

      maxWidth={false}

      PaperProps={{

        sx: {

          width: "90vw",

          height: "90vh",

          m: 0,

          borderRadius: 3,

          overflow: "hidden"

        }

      }}

    >


      <DialogTitle

        sx={{

          px: 3,

          pt: 2.5,

          pb: 1.5,

          display: "flex",

          alignItems: "center",

          justifyContent: "space-between"

        }}

      >

        <Box>

          <Box display="flex" alignItems="center" gap={1} mb={ticket ? 0.6 : 0}>
            {ticket && (
              <>
                <Tooltip title="Open ticket details">
                  <Chip
                    label={`#${ticket.ticket_id}`}
                    size="small"
                    onClick={() => navigate(`/tickets/${ticket.ticket_id}`)}
                    sx={{ cursor: "pointer", fontWeight: 700, bgcolor: "background.default", border: "1px solid", borderColor: "divider" }}
                  />
                </Tooltip>
                <Tooltip title={linkCopied ? "Link copied!" : "Copy link"}>
                  <IconButton size="small" onClick={handleCopyLink}>
                    <ContentCopyIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>

          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 700,
              color: "text.primary",
              lineHeight: 1.2
            }}
          >

            {

              ticket

                ?

                "Update Ticket"

                :

                "Create Ticket"

            }

          </Typography>


          <Typography
            sx={{
              fontSize: 13,
              color: "text.secondary",
              mt: 0.6
            }}
          >
            Capture ticket details with category, priority, assignment, and project mapping.
          </Typography>


        </Box>


        <IconButton onClick={onClose} disabled={isSaving}>
          <CloseIcon />
        </IconButton>


      </DialogTitle>







      <DialogContent

        sx={{

          px: 0,

          py: 0,

          bgcolor: "background.default"

        }}

        dividers

      >


        <Box sx={{ px: 3, py: 2.5, height: "100%" }}>


          <TicketForm

            defaultValues={ticket}

            onSubmit={onSave}

            submitRef={formRef}

            onValidityChange={setIsFormValid}


          />


        </Box>



      </DialogContent>







      <DialogActions

        sx={{

          px: 3,


          py: 2,

          gap: 1.5,

          borderTop: "1px solid",

          borderColor: "divider"

        }}

      >



        <Button

          variant="outlined"

          onClick={onClose}

          disabled={isSaving}

          sx={{

            textTransform: "none",

            borderRadius: 2

          }}

        >

          Cancel

        </Button>







        <Button

          variant="contained"

          onClick={handleSubmit}

          disabled={isSaving || !isFormValid}

          startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : null}

          sx={{

            background: uiConfig.buttonColor,

            textTransform: "none",

            borderRadius: 2,

            px: 3,

            boxShadow: "none",

            "&:hover": {
              background: "#1d4ed8",
              boxShadow: "none"
            }

          }}

        >

          {
            isSaving
              ? (ticket ? "Updating..." : "Creating...")
              : (ticket ? "Update Ticket" : "Create Task")
          }

        </Button>





      </DialogActions>





    </Dialog>


  );


}


export default TicketDialog;